var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaybutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "#D34646",
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9277 21.3218C23.9277 20.0674 23.9277 19.4402 24.1718 19.0944C24.3845 18.7932 24.7096 18.6069 25.0614 18.5843C25.4653 18.5585 25.9524 18.9064 26.9266 19.6022L39.6037 28.6573C40.4086 29.2323 40.8111 29.5197 40.9513 29.8821C41.0739 30.1989 41.0739 30.5549 40.9513 30.8717C40.8111 31.234 40.4086 31.5215 39.6037 32.0965L26.9266 41.1515C25.9524 41.8473 25.4653 42.1953 25.0614 42.1694C24.7096 42.1469 24.3845 41.9605 24.1718 41.6593C23.9277 41.3136 23.9277 40.6864 23.9277 39.432V21.3218Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybutton);
export default __webpack_public_path__ + "static/media/play button.f731ab08e832c4d79a62fb9539050c13.svg";
export { ForwardRef as ReactComponent };